import React, { useEffect, useState } from "react";
import axios from "axios";
import { Save, Loader2 } from "lucide-react";
import FileUpload from "../../components/admin/FileUpload";
import { PromoPopupPreview } from "../../components/home/PromoPopup";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// -------------------------------------------------------------
// Store info
// -------------------------------------------------------------
function StoreTab() {
  const [form, setForm] = useState({
    phone: "",
    whatsapp: "",
    email: "",
    addressLine1: "",
    addressLine2: "",
    hours: "",
    instagram: "",
    facebook: "",
    hideDefaults: false,
  });
  const [saving, setSaving] = useState(false);
  const [ok, setOk] = useState("");

  useEffect(() => {
    axios
      .get(`${API}/admin/store-settings`)
      .then((r) => {
        if (r.data && Object.keys(r.data).length) {
          setForm({
            phone: r.data.phone || "",
            whatsapp: r.data.whatsapp || "",
            email: r.data.email || "",
            addressLine1: r.data.addressLine1 || "",
            addressLine2: r.data.addressLine2 || "",
            hours: r.data.hours || "",
            instagram: r.data.instagram || "",
            facebook: r.data.facebook || "",
            hideDefaults: !!r.data.hideDefaults,
          });
        }
      })
      .catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setOk("");
    try {
      await axios.put(`${API}/admin/store-settings`, form);
      setOk("Saved ✓");
      setTimeout(() => setOk(""), 2500);
    } finally {
      setSaving(false);
    }
  };

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  return (
    <div>
      <h1 className="admin-h1">Store Info</h1>
      <p className="admin-sub">Edit contact details, hours, and social links shown across the site.</p>
      <div className="admin-card">
        <form onSubmit={submit} className="admin-form">
          <div className="admin-row two">
            <label>
              <span>Phone</span>
              <input value={form.phone} onChange={(e) => update("phone", e.target.value)} placeholder="+91 95036 50463" />
            </label>
            <label>
              <span>WhatsApp number (digits only, incl. country code)</span>
              <input value={form.whatsapp} onChange={(e) => update("whatsapp", e.target.value)} placeholder="919503650463" />
            </label>
          </div>
          <label>
            <span>Email</span>
            <input type="email" value={form.email} onChange={(e) => update("email", e.target.value)} />
          </label>
          <div className="admin-row two">
            <label>
              <span>Address line 1</span>
              <input value={form.addressLine1} onChange={(e) => update("addressLine1", e.target.value)} />
            </label>
            <label>
              <span>Address line 2</span>
              <input value={form.addressLine2} onChange={(e) => update("addressLine2", e.target.value)} />
            </label>
          </div>
          <label>
            <span>Hours</span>
            <input value={form.hours} onChange={(e) => update("hours", e.target.value)} placeholder="Mon–Sat, 10:30 AM – 8:30 PM" />
          </label>
          <div className="admin-row two">
            <label>
              <span>Instagram URL</span>
              <input value={form.instagram} onChange={(e) => update("instagram", e.target.value)} />
            </label>
            <label>
              <span>Facebook URL</span>
              <input value={form.facebook} onChange={(e) => update("facebook", e.target.value)} />
            </label>
          </div>

          <div
            style={{
              marginTop: 8,
              padding: "16px 18px",
              background: "#FBF5EC",
              border: "1px solid #E4DACB",
              borderRadius: 12,
            }}
          >
            <label
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: 12,
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                checked={form.hideDefaults}
                onChange={(e) => update("hideDefaults", e.target.checked)}
                data-testid="store-hide-defaults"
                style={{ marginTop: 4, width: 18, height: 18 }}
              />
              <span style={{ display: "block" }}>
                <strong style={{ display: "block", color: "#2B1B12" }}>
                  Hide built-in demo designs
                </strong>
                <span style={{ color: "#6B4A2F", fontSize: 13 }}>
                  When on, the public website only shows the designs you have added
                  via this admin panel. Built-in placeholder items and categories
                  with no custom designs will be hidden.
                </span>
              </span>
            </label>
          </div>

          {ok && <div className="admin-ok">{ok}</div>}
          <button type="submit" className="btn btn-primary" disabled={saving} data-testid="store-save">
            <Save size={16} /> {saving ? "Saving…" : "Save Store Info"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default StoreTab;
